/**
 * 사용자 이메일을 표시 이름으로 변환
 * Firebase Auth 또는 직접 매핑 사용
 */

// 사용자 이메일 -> 표시 이름 매핑
const userNameMap = {
  'leehoins@gmail.com': '이호인',
  'leehoins': '이호인',
  // 필요시 추가 매핑
};

/**
 * 이메일 또는 사용자 ID를 표시 이름으로 변환
 * @param {string} userIdentifier - 이메일 또는 사용자 ID
 * @returns {string} 표시 이름
 */
export const getUserDisplayName = (userIdentifier) => {
  if (!userIdentifier) return '알 수 없음';

  // 직접 매핑 확인
  if (userNameMap[userIdentifier]) {
    return userNameMap[userIdentifier];
  }

  // 이메일 형식인 경우 @ 앞부분으로 매핑 확인
  if (userIdentifier.includes('@')) {
    const username = userIdentifier.split('@')[0];
    if (userNameMap[username]) {
      return userNameMap[username];
    }
    // 매핑이 없으면 @ 앞부분 반환
    return username;
  }

  return userIdentifier;
};

/**
 * 사용자 매핑 추가 (런타임에서 동적 추가용)
 * @param {string} email - 이메일
 * @param {string} displayName - 표시 이름
 */
export const addUserMapping = (email, displayName) => {
  userNameMap[email] = displayName;
  if (email.includes('@')) {
    userNameMap[email.split('@')[0]] = displayName;
  }
};

export default getUserDisplayName;
